import React from 'react';
import { useStoreon } from 'storeon/react';
import { RootLayout } from 'common/components';
import { useRegionIdSelector } from 'modules/model-json';
import { COOKIES_STORE_NAME } from 'modules/cookies';
import { State } from 'store/types';
import { MODIFIED_KITCHEN_BREADCRUMBS, KITCHEN_PATH } from './kitchen-constants';
import { OldKitchen } from './old-kitchen';
import { NewKitchen } from './new-kitchen';

/**
 * Вью страницы "Кухни"
 */
export const Kitchen = () => {
  const regionId = useRegionIdSelector();
  const { cookies } = useStoreon<State>(COOKIES_STORE_NAME);
  const experimentCookie = cookies._proekt_kuhni;

  // _proekt_kuhni и варианты А - текущий лендос, B - акции выше, С - старый лендос

  return (
    <RootLayout customBreadcrumbs={MODIFIED_KITCHEN_BREADCRUMBS} currentPage={KITCHEN_PATH}>
      {experimentCookie === 'C'
        ? <OldKitchen regionId={regionId} />
        : <NewKitchen regionId={regionId} />
      }
    </RootLayout>
  );
};
